import FormBaseModel from '@cp-models/FormBaseModel';

export default class Tenant extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'login_code': 'string',
            'connection': 'string',
            'schema': 'string',
            'deleted_at': 'any'
        }
    }

    get contractId()
    {
        return this.schema ? this.schema.replace('u', '') : null
    }

    get deletedAt()
    {
        return this.formatDate(this.deleted_at)
    }

}
